/*
 * Haulex truck finder — Year / Make / Model → best-matching product.
 *
 * Moved verbatim from the {% javascript %} block in sections/fitment-bar.liquid
 * (Run 2). COLLECTION_URL, the DATA map and the matching/redirect rules are
 * byte-for-byte the same logic as before: which trucks and years are offered,
 * and how the destination URL is built, have not changed.
 *
 * Differences from the original, all mechanical:
 *  - scopes to [data-hx-finder] roots instead of .fitment-bar
 *  - reads [data-hx-field="…"] instead of [data-fitment="…"]
 *  - the Make select is optional (snippet param show_make: false). When it is
 *    absent the Model select is filled with every model across all makes and
 *    its values are "make:model", so every product stays reachable.
 *  - init is idempotent, so the snippet may be rendered more than once.
 */
(function () {
  if (window.__hxTruckFinderLoaded) return;
  window.__hxTruckFinderLoaded = true;

  /*
   * Fitment data → real product handles (see product-import/haulex-products.csv).
   * Each model lists its products with the year range each one fits.
   * `max: null` means open-ended (that year onward).
   */
  var COLLECTION_URL = '/collections/seat-covers';

  var DATA = {
    ford: {
      f150: { label: 'F-150', products: [
        { handle: '2009-2014-ford-f150-custom-seat-covers', min: 2009, max: 2014 },
        { handle: '2015-2020-ford-f150-custom-seat-covers', min: 2015, max: 2020 },
        { handle: '2021-ford-f150-custom-seat-covers',      min: 2021, max: null }
      ] }
    },
    chevrolet: {
      silverado: { label: 'Silverado', products: [
        { handle: '2007-2013-chevy-silverado-custom-seat-covers', min: 2007, max: 2013 },
        { handle: '2014-2018-chevy-silverado-custom-seat-covers', min: 2014, max: 2018 },
        { handle: '2019-chevy-silverado-custom-seat-covers',      min: 2019, max: null }
      ] }
    },
    gmc: {
      sierra: { label: 'Sierra', products: [
        { handle: '2014-2018-gmc-sierra-custom-seat-covers', min: 2014, max: 2018 },
        { handle: '2019-gmc-sierra-custom-seat-covers',      min: 2019, max: null }
      ] }
    },
    dodge: {
      'ram-1500':    { label: 'Ram 1500',    products: [
        { handle: '2019-dodge-ram-1500-custom-seat-covers', min: 2019, max: null }
      ] },
      'ram-2500':    { label: 'Ram 2500',    products: [
        { handle: '2019-dodge-ram-2500-custom-seat-covers', min: 2019, max: null }
      ] },
      'ram-classic': { label: 'Ram Classic', products: [
        { handle: '2009-dodge-ram-classic-custom-seat-covers', min: 2009, max: null }
      ] }
    },
    toyota: {
      tacoma: { label: 'Tacoma', products: [
        { handle: '2016-2023-toyota-tacoma-custom-seat-covers', min: 2016, max: 2023 },
        { handle: '2024-toyota-tacoma-custom-seat-covers',      min: 2024, max: null }
      ] },
      tundra: { label: 'Tundra', products: [
        { handle: '2013-2021-toyota-tundra-custom-seat-covers', min: 2013, max: 2021 },
        { handle: '2022-toyota-tundra-custom-seat-covers',      min: 2022, max: null }
      ] }
    }
  };

  /* Resolve the chosen make + model to a model object, whether the Make select
     is present (model value is a bare key) or not (model value is "make:key"). */
  function resolveModel(makeValue, modelValue) {
    if (!modelValue) return null;

    if (makeValue) {
      return DATA[makeValue] ? DATA[makeValue][modelValue] || null : null;
    }

    var parts = modelValue.split(':');
    if (parts.length !== 2) return null;
    return DATA[parts[0]] ? DATA[parts[0]][parts[1]] || null : null;
  }

  function initFinder(root) {
    if (root.hasAttribute('data-hx-finder-ready')) return;
    root.setAttribute('data-hx-finder-ready', '');

    var yearSelect  = root.querySelector('[data-hx-field="year"]');
    var makeSelect  = root.querySelector('[data-hx-field="make"]');
    var modelSelect = root.querySelector('[data-hx-field="model"]');
    var submitBtn   = root.querySelector('[data-hx-field="submit"]');

    if (!modelSelect || !submitBtn) return;

    if (makeSelect) {
      makeSelect.addEventListener('change', function () {
        var models = DATA[this.value] || {};
        var keys = Object.keys(models);

        modelSelect.innerHTML = keys.length
          ? '<option value="">Model</option>'
          : '<option value="">Select Make First</option>';

        keys.forEach(function (key) {
          var opt = document.createElement('option');
          opt.value = key;
          opt.textContent = models[key].label;
          modelSelect.appendChild(opt);
        });

        modelSelect.disabled = keys.length === 0;
      });
    } else {
      /* No Make select: list every model, namespaced by make. */
      Object.keys(DATA).forEach(function (make) {
        Object.keys(DATA[make]).forEach(function (key) {
          var opt = document.createElement('option');
          opt.value = make + ':' + key;
          opt.textContent = DATA[make][key].label;
          modelSelect.appendChild(opt);
        });
      });
      modelSelect.disabled = false;
    }

    submitBtn.addEventListener('click', function () {
      var make = makeSelect ? makeSelect.value : '';
      var modelValue = modelSelect.value;
      var year = parseInt(yearSelect ? yearSelect.value : '', 10);

      var model = resolveModel(make, modelValue);

      if (!model) {
        // Not enough info to match a product — send them to browse all covers.
        window.location.href = COLLECTION_URL;
        return;
      }

      var products = model.products;
      var match = null;

      if (year) {
        for (var i = 0; i < products.length; i++) {
          var p = products[i];
          if (year >= p.min && (p.max === null || year <= p.max)) {
            match = p;
            break;
          }
        }
      } else {
        // No year chosen: default to the newest (open-ended) product.
        match = products[products.length - 1];
      }

      window.location.href = match
        ? '/products/' + match.handle
        : COLLECTION_URL;
    });
  }

  function init() {
    document.querySelectorAll('[data-hx-finder]').forEach(initFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init when the theme editor re-renders a section containing a finder. */
  document.addEventListener('shopify:section:load', init);
})();
